import { render, staticRenderFns } from "./select-client.vue?vue&type=template&id=154dc2d0&"
import script from "./select-client.vue?vue&type=script&lang=js&"
export * from "./select-client.vue?vue&type=script&lang=js&"
import style0 from "./select-client.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154dc2d0')) {
      api.createRecord('154dc2d0', component.options)
    } else {
      api.reload('154dc2d0', component.options)
    }
    module.hot.accept("./select-client.vue?vue&type=template&id=154dc2d0&", function () {
      api.rerender('154dc2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/modal/select-client/select-client.vue"
export default component.exports